import React, { useEffect, useRef } from "react";
import Modal from "@mui/material/Modal";
import useMediaQuery from "@mui/material/useMediaQuery";
import SwipeableDrawer, {
  SwipeableDrawerProps,
} from "@mui/material/SwipeableDrawer";
import Box from "@mui/material/Box";
import Fade from "@mui/material/Fade";
import DragHandleIcon from "@mui/icons-material/DragHandle";

interface DrawerModalProps extends SwipeableDrawerProps {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
  anchor: "top" | "left" | "bottom" | "right";
}

const iOS =
  typeof navigator !== "undefined" &&
  /iPad|iPhone|iPod/.test(navigator.userAgent);

const DrawerModal: React.FC<DrawerModalProps> = ({
  isOpen,
  onClose,
  children,
  anchor,
  ...props
}: DrawerModalProps) => {
  const isMobileOrTablet = useMediaQuery("(max-width:960px)");
  const contentRef = useRef<HTMLDivElement>(null);

  // useEffect(() => {
  //   const handlePopState = () => {
  //     if (isOpen) {
  //       onClose();
  //     }
  //   };

  //   if (isOpen) {
  //     window.history.pushState(null, "", window.location.href);
  //     window.addEventListener("popstate", handlePopState);
  //   } else {
  //     window.removeEventListener("popstate", handlePopState);
  //   }

  //   return () => {
  //     window.removeEventListener("popstate", handlePopState);
  //   };
  // }, [isOpen, onClose]);

  const modalStyle: React.CSSProperties = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    maxWidth: isMobileOrTablet ? "75%" : "80%",
    maxHeight: "75%", // Set maximum height to 75%
    backgroundColor: "background.paper",
    border: "0px solid #e78758",
    borderRadius: "16px",
    boxShadow: "24px", // You can replace this with your intended value or remove it
    padding: 2,
    overflowY: "auto", // Add this line to enable vertical scrolling
    wordWrap: "break-word", // Ensure content doesn't wrap to the next line
  };

  if (isMobileOrTablet) {
    return (
      <>
        <SwipeableDrawer
          anchor="bottom"
          open={isOpen}
          onClose={onClose}
          disableBackdropTransition={!iOS}
          disableDiscovery={iOS}
          {...props}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              paddingTop: "0px",
              paddingBottom: "16px", // Adjust the padding as needed
              paddingRight: "16px",
              paddingLeft: "16px",
            }}
            role="presentation"
          >
            {/* Add the custom icon here */}
            <DragHandleIcon
              style={{ fontSize: 36, marginBottom: "0px", color: "#CCCCCC" }}
              onClick={onClose}
            />
            {isOpen && <Box>{children}</Box>}
          </Box>
        </SwipeableDrawer>
      </>
    );
  }

  return (
    <>
      <Modal
        open={isOpen}
        onClose={onClose}
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
        disableScrollLock
      >
        <Fade in={isOpen}>
          <Box sx={modalStyle} ref={contentRef}>
            {children}
          </Box>
        </Fade>
      </Modal>
    </>
  );
};

export { DrawerModal };
